import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CostProfile, Identifiable, Resource } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeCostProfileFromResource(
    data: Boundaries["removeCostProfileFromResource"]["request"],
  ): void;
}

function useRemoveCostProfileFromResource(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveCostProfileFromResourceRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveCostProfileFromResourceRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveCostProfileFromResourceRequestFailure(resource),
    ),
    removeCostProfileFromResource: core.removeCostProfileFromResource,
  };
}

export { useRemoveCostProfileFromResource };
